<div class="doc-verdict" [attr.data-tone]="tone()">
  <span class="doc-verdict__status" aria-hidden="true">
    @if (tone() === 'evaluating') {
      <mat-spinner diameter="18" />
    } @else {
      <app-icon [name]="icon()" [size]="18" />
    }
  </span>
  <span class="doc-verdict__body">
    <span class="doc-verdict__name">{{ fileName() }}</span>
    @if (note()) {
      <span class="doc-verdict__msg">{{ note() }}</span>
    }
  </span>
  <span class="doc-verdict__badge">{{ statusLabel() }}</span>
  <ng-content select="[doc-verdict-trailing]" />
</div>
